export const getFirstTwoWords = (text: string) => {
  if (!text) return '';
  return text.split(' ').slice(0, 2).join(' ');
};
